<script>
export default {
  props: {
    icon: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'primary'
    },
    dialogColor: {
      type: String
    },
    title: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledOuterButton: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      dialog: false
    }
  }
}
</script>
<template>
  <v-dialog v-model="dialog" max-width="500">
    <template #activator="{ on, attrs }">
      <v-tooltip v-if="$slots.tooltip" top>
        <template #activator="{ on: tooltip }">
          <v-btn
            :color="color"
            :disabled="disabledOuterButton"
            icon
            dark
            v-bind="{ ...attrs }"
            v-on="{ ...on, ...tooltip }"
            @click.stop="$emit('activated')">
            <v-icon :color="color">{{ icon }}</v-icon>
          </v-btn>
        </template>
        <span><slot name="tooltip"></slot></span>
      </v-tooltip>
      <v-btn
        v-else
        :color="color"
        :disabled="disabledOuterButton"
        icon
        dark
        v-bind="attrs"
        v-on="on">
        <v-icon :color="color">{{ icon }}</v-icon>
      </v-btn>
    </template>
    <v-card>
      <DialogBaseColoredTitle :color="dialogColor || color">
        <h2 class="headline text--white">
          {{ title.length > 0 ? title : $t('component.profile.administrationManagement.delete.entry') }}
        </h2></DialogBaseColoredTitle>
      <DialogBaseCloseIcon
        color="white"
        @click="$emit('canceled')
        dialog = false"/>
      <v-divider></v-divider>
      <DialogBaseText>
        <slot name="content"></slot>
      </DialogBaseText>
      <v-divider></v-divider>
      <DialogBaseActions>
        <v-btn
          color="secondary" @click="
          $emit('canceled')
          dialog = false">
          {{ $t('button.cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          :color="dialogColor || color"
          :disabled="disabled"
          @click="
            $emit('confirmed')
            dialog = false">
          {{ $t('button.confirm') }}
        </v-btn>
      </DialogBaseActions
      >
    </v-card>
  </v-dialog>
</template>
